module.exports = "https://coursera_assets.s3.amazonaws.com/images/6fa5d46e08c1cd6444ed695a1158bf0e.png";